import { useState } from "react";

import { StoreSearchControlsComponent } from "./storeSearchControls.components";

export const StoreSearchControls = () => {
    const [filtersOpen, setFiltersOpen] = useState<boolean>(false);

    const toggleFilters = () => setFiltersOpen((open) => !open);

    return (
        <StoreSearchControlsComponent
            filtersOpen={filtersOpen}
            toggleFilters={toggleFilters}
        />
    );
};
